//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Story',

  data() {
    return {
      CDN: process.env.CDN,
      activeParagraph: 0,
    };
  },

  computed: {
    ...mapState(['story', 'isMobile']),
    ...mapGetters(['imgSuffix']),
    chapterId() {
      return Number(this.$route.params.chapterId);
    },
    backgroundImageSrc() {
      return `${this.CDN}/story/feature_story_slider_bg_${this.chapterId}${this.imgSuffix}.jpg`;
    },
  },

  methods: {
    handleBtnPrevParagraphClick() {
      this.activeParagraph -= 1;
    },
    handleBtnNextParagraphClick() {
      this.activeParagraph += 1;
    },
  },

  async validate({ store, params }) {
    const story = await store.dispatch('getStory', params.chapterId);

    return !!story;
  },
};
